import axios from '@app/services/axios';

export interface DashboardKPIs {
  totalRealizedRevenue: number;
  walletRechargeAmount: number;
  walletRechargeCount: number;
  directRevenue: number;
  directCount: number;
  walletOrdersSpent: number;
  walletOrdersCount: number;
  totalOrdersCount: number;
  activeSubscriptions: number;
  totalSubscriptions: number;
  totalClients: number;
  newClientsInRange: number;
  activeClients: number;
  clientActiveRatio: number;
}

export interface TodayDeliveries {
  todayDelivered: number;
  todayScheduled: number;
  todayCancelled: number;
  todayTotal: number;
  fulfillmentRate: number;
}

export interface TimelinePoint {
  date: string;
  directRevenue: number;
  walletSpent: number;
  rechargeAmount: number;
  orderCount: number;
  totalRealized: number;
}

export interface TopProduct {
  rank: number;
  name: string;
  totalQty: number;
  totalRevenue: number;
  orderCount: number;
}

export interface RecentOrder {
  _id: string;
  orderId: number | string;
  amount: number;
  payment_method: string;
  status: string;
  clientName: string;
  phone: string;
  createdAt: string;
}

export interface DashboardMetricsResponse {
  success: boolean;
  timeRange: string;
  kpis: DashboardKPIs;
  deliveries: TodayDeliveries;
  timeline: TimelinePoint[];
  topProducts: TopProduct[];
  recentOrders: RecentOrder[];
}

export const getDashboardMetrics = (timeRange: string = 'all'): Promise<DashboardMetricsResponse> =>
  axios.get<DashboardMetricsResponse>(`/api/admin/dashboard/metrics?timeRange=${timeRange}`).then((res) => res.data);
